import React, { useEffect, useRef, useState } from 'react';
import { Button, Col, Divider, Row, Select } from 'antd';
import { useTranslation } from 'react-i18next';
import { isEqual } from 'lodash';

export const OptionsFilterMultiple = (props: any) => {
  const inputRef = useRef<any>(null);
  const { t } = useTranslation();
  const [values, setValues] = useState<string[]>([]);
  const [appliedValues, setAppliedValues] = useState<string[]>([]);
  const [filterModeChanged, setFilterModeChanged] = useState(false);

  useEffect(() => {
    inputRef.current?.focus();
  }, [inputRef]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div style={{ margin: '10px 20px 10px 20px' }} className="filter-custom-clear">
      <Select
        optionFilterProp="label"
        mode="multiple"
        onClear={() => {
          setValues([]);
          props.onChange();
        }}
        style={{ width: '345px' }}
        options={props.options || []}
        onChange={(v) => setValues(v)}
        allowClear
        value={values}
      />
      <Divider style={{ marginTop: '10px', marginBottom: '10px' }} />
      {props.allowChangeFilterMode && (
        <Row>
          <Col span={24}>
            <span>{t('FilterMode')}</span>
          </Col>
          <Col span={24}>
            <Select
              defaultValue={'Any'}
              style={{ width: '100%', marginBottom: '10px' }}
              onChange={(mode) => {
                props.changeFilterMode(mode);
                setFilterModeChanged(true);
              }}
              options={[
                { label: t('AllSelected'), value: 'All' },
                { label: t('AnyOfTheSelected'), value: 'Any' },
              ]}
            ></Select>
          </Col>
        </Row>
      )}
      <Button
        disabled={values?.length === 0}
        type="primary"
        style={{ height: '40px', width: '100%', marginTop: 10 }}
        onClick={() => {
          if (isEqual(values, appliedValues) && !filterModeChanged) {
            setValues([]);
            setAppliedValues([]);
            props.onChange();
          } else {
            setAppliedValues(values);
            setFilterModeChanged(false);
            props.onChange(values);
          }
        }}
      >
        {values.length !== 0 && isEqual(values, appliedValues) && !filterModeChanged ? t('ClearFilter') : t('Apply')}
      </Button>
    </div>
  );
};
